import React from 'react'
import FirstStep from '../Components/FirstStep'
import FourthStep from '../Components/FourthStep'
import SecondStep from '../Components/SecondStep'
import ThirdStep from '../Components/ThirdStep'

const allSteps = [
  'Select Batch',
  'Upload Audition Video',
  'Add a Message',
  'Confirmation',
]

const defaultActiveComp = (activeStep, props) => {
  switch (activeStep) {
    case 0:
      return <FirstStep {...props} />
    case 1:
      return <SecondStep {...props} />
    case 2:
      return <ThirdStep {...props} />
    case 3:
      return <FourthStep {...props} />
    default:
      return null
  }
}

export const getGroupRegState = (withAuditionVid, withApproval) => {
  let steps = allSteps
  let getActiveComp = defaultActiveComp

  if (!withApproval) {
    steps = steps.slice(0, 1)
    getActiveComp = (activeStep, props) => {
      switch (activeStep) {
        default:
          return <FirstStep withApproval={withApproval} {...props} />
      }
    }
  } else if (!withAuditionVid) {
    steps = [...steps.slice(0, 1), ...steps.slice(2)]
    getActiveComp = (activeStep, props) => {
      switch (activeStep) {
        case 0:
          return <FirstStep {...props} />
        case 1:
          return <ThirdStep {...props} />
        case 2:
          return <FourthStep withAuditionVid={withAuditionVid} {...props} />
        default:
          return null
      }
    }
  }

  return [steps, getActiveComp]
}
